import { FC } from 'react';
import { Box, BoxProps, CircularProgress, CircularProgressProps } from '@mui/material';

export type LoadingProps = {
  BoxProps?: BoxProps;
  CircularProgressProps?: CircularProgressProps;
};

export const Loading: FC<LoadingProps> = ({
  BoxProps: boxProps,
  CircularProgressProps: circularProgressProps,
}) => (
  <Box
    alignItems='center'
    display='flex'
    height={1}
    justifyContent='center'
    width={1}
    {...boxProps}
  >
    <CircularProgress {...circularProgressProps} />
  </Box>
);
